export { default as ManageBanner } from './ManageBanner';
